import styled from "styled-components";

export const FormInputGroup = styled.div`
  margin-bottom: 8px;
  text-align: left;
  font-family: Poppins;
  font-size: 14px;
  position:relative;
    
  label {
    margin-bottom: 0.5rem;
    display: inline-block ;
    color: gray;
    font-size: 14px;
    font-weight: 500;
    line-height: 160%;
    letter-spacing: 0.24%;
    vertical-align: middle;

    }`
